// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__XlhE8","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2H8sR"};